import valid from 'card-validator';

export const SUPPORTED_CARD_BRANDS = ['visa', 'mastercard', 'jcb'];

export const detectPaymentCard = number => {
  const digits = String(number || '').replace(/\s/g, '');
  // Inspect only the prefix for the brand: a mistyped checksum must not change the icon.
  const prefix = digits.slice(0, 8);
  const card = valid.number(prefix).card;
  // Visa shares early prefixes with other networks; prefer Visa until a stronger match exists.
  const brand = card?.type || (/^4/.test(prefix) ? 'visa' : null);
  const unsupported = brand ? !SUPPORTED_CARD_BRANDS.includes(brand) : prefix.length >= 6;
  return { brand, unsupported, isValid: valid.number(digits).isValid };
};
